import styled from 'styled-components';

export const DropdownLegacyWrapper = styled.div`
  margin: calc(-1 * var(--list-padding));
`;
